import Icon from '@/components/ui/AppIcon';

interface Benefit {
  icon: string;
  title: string;
  description: string;
}

const BenefitsSection = () => {
  const benefits: Benefit[] = [
    {
      icon: 'ArrowTrendingUpIcon',
      title: 'Průběžná optimalizace',
      description: 'Váš plán se neustále vylepšuje na základě nových příležitostí a změn na trhu. Nemusíte sledovat každou změnu sami.',
    },
    {
      icon: 'ShieldCheckIcon',
      title: 'Ochrana před riziky',
      description: 'Pravidelně kontrolujeme vaše pojištění a investice, abychom zajistili, že jste chráněni proti neočekávaným událostem.',
    },
    {
      icon: 'UserGroupIcon',
      title: 'Osobní přístup',
      description: 'Znáte svého poradce osobně a můžete se na něj kdykoliv obrátit. Nejste jen číslo v systému.',
    },
    {
      icon: 'ClockIcon',
      title: 'Úspora času',
      description: 'Nemusíte trávit hodiny studiem finančních produktů a trendů. My to děláme za vás a přinášíme vám jen relevantní informace.',
    },
    {
      icon: 'ChartBarIcon',
      title: 'Měřitelný pokrok',
      description: 'Pravidelně vyhodnocujeme, jak se blížíte k vašim cílům, a upravujeme strategii pro maximální efektivitu.',
    },
    {
      icon: 'LightBulbIcon',
      title: 'Proaktivní řešení',
      description: 'Nepřicházíme s řešeními až když je problém. Předvídáme změny a připravujeme vás na ně předem.',
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4 font-headline">
              Výhody živého finančního plánu
            </h2>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              Proč je náš přístup k finančnímu plánování efektivnější než tradiční metody
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-card p-6 rounded-xl shadow-card hover:shadow-elevated transition-smooth border border-border group"
              >
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary group-hover:scale-110 transition-smooth">
                  <Icon
                    name={benefit.icon as any}
                    size={28}
                    className="text-primary group-hover:text-white transition-smooth"
                  />
                </div>
                <h3 className="text-lg font-semibold text-text-primary mb-3">
                  {benefit.title}
                </h3>
                <p className="text-sm text-text-secondary leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-gradient-to-r from-primary to-secondary rounded-xl p-8 lg:p-12 text-white text-center">
            <h3 className="text-2xl lg:text-3xl font-bold mb-4 font-headline">
              Váš plán roste s vámi
            </h3>
            <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto">
              Nemusíte se bát změn. Ať už jde o novou práci, rodinu, nebo neočekávanou situaci – váš finanční plán se přizpůsobí a pomůže vám najít nejlepší cestu vpřed.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/online-initial-diagnosis"
                className="w-full sm:w-auto px-8 py-4 bg-accent text-accent-foreground font-semibold rounded-lg hover:bg-accent/90 hover:shadow-hover hover:scale-105 transition-smooth inline-flex items-center justify-center space-x-2"
              >
                <span>Začít s diagnózou</span>
                <Icon name="ArrowRightIcon" size={20} className="text-current" />
              </a>
              <a
                href="/first-meeting-analysis"
                className="w-full sm:w-auto px-8 py-4 bg-white/20 backdrop-blur-sm text-white font-semibold rounded-lg hover:bg-white/30 transition-smooth inline-flex items-center justify-center space-x-2"
              >
                <span>První schůzka</span>
                <Icon name="CalendarIcon" size={20} className="text-current" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;